(function () {
    App.controller('HealthInsuranceInfoRefundCtrl', HealthInsuranceInfoRefundCtrl);
    HealthInsuranceInfoRefundCtrl.$inject = ['$scope', '$state', '$rootScope', '$window', 'HealthInsuranceComplaintRefundService', 'popUpService'];

    function HealthInsuranceInfoRefundCtrl($scope, $state, $rootScope, $window, HealthInsuranceComplaintRefundService, popUpService) {
        var self = this;

        self.goToForm = function () {
            HealthInsuranceComplaintRefundService.hasAccessToForm()
                .then(function (success) {
                    return success && success.data && success.data.result;
                }, function (error) {
                    return false;
                })
                .then(function (hasAccess) {
                    if (hasAccess) {
                        if (!$window.sessionStorage.getItem('isLogged')) {
                            $window.sessionStorage.removeItem('isLogged');
                            $window.sessionStorage.removeItem('token');
                            $window.sessionStorage.removeItem('params');
                            $window.sessionStorage.removeItem('userObject');
                            $rootScope.__logged = false;
                            $rootScope.__isAccess = false;
                            $rootScope.__isInsurer = false;
                            $state.go('root.login');
                            return;
                        }
                        $state.go('root.home.healthInsurance.refundForm');
                    } else {
                        popUpService.showPopUp({tpl: 'info-big', head:'Reklamacje/refundacje', content:'Musisz mieć aktywny pakiet, aby skorzystać ze zgłoszeń reklamacji lub refundacji.'});
                    }
                });
        };

        initPage();

        function initPage() {
            $scope.page = 'healthInsuranceInfo_refund';
            $scope.$emit('page', $scope.page);

            $scope.step = 'Reklamacje/refundacje';
            $scope.$emit('step', $scope.step);

            $scope.link = 'root.dashboard';
            $scope.$emit('link', $scope.link);
        }
    }
})();
